import { apiClient } from './api';
import type {
  InvitationSummaryDto,
  InvitationActionResponse,
  InvitationTokenDetailDto,
  ReceivedInvitationDto,
  SendInvitationRequest,
} from '../types/coOwnershipInvitation';

export const coOwnershipInvitationService = {
  async listByApartment(apartmentId: string): Promise<InvitationSummaryDto[]> {
    const response = await apiClient.get<InvitationSummaryDto[]>(
      `/apartments/${apartmentId}/co-ownership/invitations`
    );
    return response.data;
  },

  async sendInvitation(
    apartmentId: string,
    request: SendInvitationRequest
  ): Promise<InvitationActionResponse> {
    const response = await apiClient.post<InvitationActionResponse>(
      `/apartments/${apartmentId}/co-ownership/invitations`,
      request
    );
    return response.data;
  },

  async revokeInvitation(apartmentId: string, invitationId: string): Promise<void> {
    await apiClient.post(
      `/apartments/${apartmentId}/co-ownership/invitations/${invitationId}/revoke`
    );
  },

  async resendInvitation(
    apartmentId: string,
    invitationId: string
  ): Promise<InvitationActionResponse> {
    const response = await apiClient.post<InvitationActionResponse>(
      `/apartments/${apartmentId}/co-ownership/invitations/${invitationId}/resend`
    );
    return response.data;
  },

  async getByToken(token: string): Promise<InvitationTokenDetailDto> {
    const response = await apiClient.get<InvitationTokenDetailDto>(`/invitations/${token}`);
    return response.data;
  },

  async listReceived(): Promise<ReceivedInvitationDto[]> {
    const response = await apiClient.get<ReceivedInvitationDto[]>(
      '/co-ownership/invitations/received'
    );
    return response.data;
  },

  async acceptInvitation(apartmentId: string, token: string): Promise<InvitationActionResponse> {
    const response = await apiClient.post<InvitationActionResponse>(
      `/apartments/${apartmentId}/co-ownership/invitations/accept`,
      { token }
    );
    return response.data;
  },

  async rejectInvitation(apartmentId: string, token: string): Promise<InvitationActionResponse> {
    const response = await apiClient.post<InvitationActionResponse>(
      `/apartments/${apartmentId}/co-ownership/invitations/reject`,
      { token }
    );
    return response.data;
  },

  async removeCoOwner(apartmentId: string, ownerSub: string): Promise<void> {
    await apiClient.delete(`/apartments/${apartmentId}/co-ownership/${ownerSub}`);
  },
};
